import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormControl, FormGroup, AbstractControl } from '@angular/forms';
import { APIURLRegisterService } from '../../_services/url-register/API-urlregister';
import { Constants } from '../../../../_utils/Constants';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { Router } from "@angular/router";
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';

let now = new Date();

@Component({
  selector: 'app-url-registration',
  templateUrl: './url-registration.component.html',
  styleUrls: ['./url-registration.component.css']
})
export class UrlRegistrationComponent implements OnInit {
  urlRegistrationForm: FormGroup;

  EntityID: any
  EntityName: any

  urlType: any = "longUrl";
  ctaType: any;
  cta_sub_type: any;
  ctaValue: any;
  short_domain: any = "";
  myfilesapk: any[] = [];
  fileSizeError1apk: any;
  fileSizeError2apk = false;
  photoName1: any;
  fileExtensionErrorapk: boolean = false;
  document1: any[] = [];
  fileExtensionMessage: any;
  docfiles1: any;
  photoContent: any;
  fileExtension: any;
  headerlist: any = [];
  selectedHeader: any;
  getValue: any;
  chksubmitted = false;

  constructor(private fb: FormBuilder,
    private urlApi: APIURLRegisterService,
    private db: $DBManagerService,
    private $modal: $ModalManagerService,
    private router: Router,
  ) {
    this.EntityID = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID)
    this.EntityName = this.db.get(Constants.SESSSION_STORAGE, Constants.ORG_NAME)
  }

  ngOnInit() {

    this.urlRegistrationForm = this.fb.group({
      entityID: [''], //To allow from 15 to 19 digits
      entityName: [''],
      cta_type: ['', [Validators.required]],
      cta_sub_type: ['', [Validators.required]],
      ctaValue: ['', [Validators.required]],
      remarks: [''],
      apkurl: [''],
      header_list: [''],
      short_domain: [''],
      whitelist: ['', [Validators.required]],

    }, {

    });
    this.urlRegistrationForm.controls['entityID'].setValue(this.EntityID);
    this.urlRegistrationForm.controls['entityName'].setValue(this.EntityName);
  }

  openDropdown(event) {
    this.urlType = event.value;
  }
  tbDeSelect(event1): void {
    if (event1.checked) {
      this.chksubmitted = true

    }
    else {
      this.chksubmitted = false
    }
    console.log("event: ", event1);

  }
  onChangeAction(event) {
    this.selectedHeader = event.value;
  }

  openAttributType(event) {
    console.log("ctaTypeav--------", event.value)
    this.ctaType = event.value;
  }

  openSubAttributType(event) {
    console.log("ctaSubType--------", event.value)
    this.urlRegistrationForm.controls['ctaValue'].reset()
    this.cta_sub_type = event.value;
    if (this.cta_sub_type == "mobile_number") {
      this.urlRegistrationForm.controls['ctaValue'].clearValidators();
      this.urlRegistrationForm.controls['ctaValue'].setValidators([Validators.minLength(12), Validators.maxLength(12), Validators.pattern("^[9][1][6-9][0-9]*$")])
      this.urlRegistrationForm.controls['ctaValue'].updateValueAndValidity();
    } else if (this.cta_sub_type == "landline_number") {
      this.urlRegistrationForm.controls['ctaValue'].clearValidators();
      this.urlRegistrationForm.controls['ctaValue'].setValidators([Validators.minLength(11), Validators.maxLength(11), Validators.pattern("^[0][0-9]*$")])
      this.urlRegistrationForm.controls['ctaValue'].updateValueAndValidity();
    } else if (this.cta_sub_type == "tollfree_number") {
      this.urlRegistrationForm.controls['ctaValue'].clearValidators();
      this.urlRegistrationForm.controls['ctaValue'].setValidators([Validators.minLength(8), Validators.maxLength(11), Validators.pattern("^([1][8][0][0]|[1][8][6][0])[0-9]*$")])
      this.urlRegistrationForm.controls['ctaValue'].updateValueAndValidity();
    } else if (this.ctaType == "email") {
      this.urlRegistrationForm.controls['ctaValue'].clearValidators();
      this.urlRegistrationForm.controls['ctaValue'].setValidators([Validators.pattern('^[A-Za-z0-9._-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,10}$')]);
      this.urlRegistrationForm.controls['ctaValue'].updateValueAndValidity();
    } else if (this.ctaType == "url") {
      //const reg = '((https?://)|(www.))(([\\da-z.-]+)\\.([a-z 0-9.-]{2,250})*/|([a-z 0-9/.-]{2,250})(/?))?';
      // const reg = '(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?';
      // const regapk = '((https?://)|(www.))(([\\da-z.-]+)\\.([a-z 0-9.-]{2,250})*/|([a-z 0-9/.-]{2,250})([/\\.apk(?i)]|[/\\.ipa(?i)]))?';
      // const regdynamic  =  '(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-][^\s]+([?])';
      //const regdynamic = '((https?://)|(www.))(([\\da-z.-]+)\\.([a-z 0-9.-]{2,250})*/|([a-z 0-9/.-]{2,250}))+([?])';
      
      const reg = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/;
      const regapk = '((https?://)|(www.))(([\\da-z.-]+)\\.([a-z 0-9.-]{2,250})*/|([a-z 0-9/.-]{2,250})([/\\.apk(?i)]|[/\\.ipa(?i)]))?';
      const regdynamic = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+([?])/;

      this.urlRegistrationForm.controls['ctaValue'].clearValidators();
      if (this.cta_sub_type == 'apk_url') {
        this.urlRegistrationForm.controls['ctaValue'].clearValidators();
        //this.urlRegistrationForm.controls['ctaValue'].setValidators([Validators.pattern(/^(http:\/\/|https:\/\/|www\.)[^\s]+\.apk$/i)])
        this.urlRegistrationForm.controls['ctaValue'].setValidators([Validators.pattern(regapk)])
      } else if (this.cta_sub_type == 'dynamic_url') {
        this.urlRegistrationForm.controls['ctaValue'].clearValidators();
        this.urlRegistrationForm.controls['ctaValue'].setValidators([Validators.pattern(regdynamic)])
      }
      else {
        //this.urlRegistrationForm.controls['ctaValue'].setValidators([Validators.pattern(/^(http:\/\/|https:\/\/|www\.)[^\s]+$/i)]);

        this.urlRegistrationForm.controls['ctaValue'].setValidators([Validators.pattern(reg)]);
      }

      if (this.cta_sub_type == "short_url") {
        console.log("avi short");
        this.urlApi.listPrincipalEntityHeaderSMSDLT(this.EntityID).subscribe(val => {
          this.getValue = val.data;
          this.getValue.forEach(element => {
            console.log("ELEMENT", element)

            this.headerlist.push(element.cli)

          });
          console.log("HEEEEEADERS list", this.headerlist)
        });
        this.urlRegistrationForm.controls['ctaValue'].clearValidators();
      }
      this.urlRegistrationForm.controls['ctaValue'].updateValueAndValidity();
    } else {
      this.urlRegistrationForm.controls['ctaValue'].clearValidators();
      this.urlRegistrationForm.controls['ctaValue'].updateValueAndValidity();
    }
  }

  updateCtaValue() {
    this.ctaValue = this.short_domain + '/' + this.urlRegistrationForm.get('header_list').value;
  }

  onChangeapkFileUpload(event) {

    this.myfilesapk = event.target.files;
    var file = event.target.files[0];
    this.photoName1 = file.name;
    let fileNameArr = this.photoName1.split('.')
    this.docfiles1 = this.document1.push(file);

    console.log("the size is ", file.size)
    if (file.size > 20000000) {
      console.log("The size is more ")
      this.fileSizeError1apk = true;
      this.urlRegistrationForm.controls['apkurl'].reset();
      this.photoName1 = ''
      this.myfilesapk = null
      this.document1 = []

    }
    else {
      this.fileSizeError1apk = false;
    }
    if (file.size <= 0) {
      console.log("The size is less ")
      this.fileSizeError2apk = true;
      this.urlRegistrationForm.controls['apkurl'].reset();
      this.photoName1 = ''
      this.myfilesapk = null
      this.document1 = []

    }
    else {
      this.fileSizeError2apk = false;
    }
    var allowedExtensions =
      ["apk", "APK"];
    this.fileExtension = this.photoName1.split('.').pop();
    console.log("this.photoName   ----------- ", this.photoName1)

    if (this.isInArray(allowedExtensions, this.fileExtension)) {
      this.fileExtensionErrorapk = false;
      this.fileExtensionMessage = ""
    } else {
      this.fileExtensionMessage = "Only apk files allowed!!"
      this.fileExtensionErrorapk = true;
      this.urlRegistrationForm.controls['apkurl'].reset();
      this.photoName1 = ''
      this.myfilesapk = null
      this.document1 = []
    }
    console.log("this.document1=========", this.document1)
    if (file) {
      var reader = new FileReader();
      reader.onloadend = (e: any) => {
        var contents = e.target.result;
        this.photoContent = contents;
      }
      reader.readAsDataURL(file);
    } else {
      alert("Failed to load file");
    }
    console.log("this is file extension error", this.fileExtensionErrorapk);
    //  }
  }

  resetapk() {
    this.fileExtensionErrorapk = false;
    this.fileSizeError1apk = false;
    this.fileSizeError2apk = false;
    this.photoName1 = ''
    this.myfilesapk = []
    this.urlRegistrationForm.controls['apkurl'].reset();
  }

  isInArray(array, word) {
    return array.indexOf(word.toLowerCase()) > -1;
  }

  reset() {
    this.urlRegistrationForm.controls["remarks"].reset();
    this.urlRegistrationForm.controls['cta_type'].reset();
    this.urlRegistrationForm.controls['cta_sub_type'].reset();
    this.urlRegistrationForm.controls['ctaValue'].reset();
    this.urlRegistrationForm.controls['apkurl'].reset();
    this.urlRegistrationForm.controls['header_list'].reset();
    this.urlRegistrationForm.controls['short_domain'].reset();

  }

  get f() { return this.urlRegistrationForm.controls; }

  async onSubmit() {
    // this.submitted = true;
    console.log("this.urlRegistrationForm-----", this.urlRegistrationForm)

    if (this.chksubmitted === false) {
      this.$modal.errorModal({
        title: 'Whitelisting Request By PE',
        msg: "Please Select The Checkbox"

      });
      return;
    }
    if (this.urlRegistrationForm.invalid || this.fileExtensionErrorapk || this.fileSizeError1apk || this.fileSizeError2apk) {
      return;
    } else if (this.cta_sub_type == "apk_url" && this.document1.length == 0) {
      alert("Please attach APK File")
      return;
    }  else {
      const urlRegistrationForm: FormData = new FormData();
      urlRegistrationForm.append('peid', this.urlRegistrationForm.get("entityID").value);
      urlRegistrationForm.append('pename', this.urlRegistrationForm.get("entityName").value);
      urlRegistrationForm.append('ctaType', this.urlRegistrationForm.get("cta_type").value);
      urlRegistrationForm.append('ctaSubType', this.urlRegistrationForm.get("cta_sub_type").value);
      urlRegistrationForm.append('ctaValue', this.urlRegistrationForm.get("ctaValue").value);
      urlRegistrationForm.append('header', this.urlRegistrationForm.get("header_list").value);
      urlRegistrationForm.append('shortDomain', this.urlRegistrationForm.get("short_domain").value);

      urlRegistrationForm.append('apkurl', this.document1[0]);
      urlRegistrationForm.append('remarks', this.urlRegistrationForm.get("remarks").value);
      urlRegistrationForm.append('status', ((this.ctaType == 'number' || this.ctaType == 'email') ? "A" : "P"));

      console.log("urlRegistrationForm--------", urlRegistrationForm)
      let displayMsg;
      if (this.ctaType == 'number') {
        displayMsg = "Your Whitelisting request has been succesfully submitted . URN-"
      } else {
        displayMsg = "Your Whitelisting request has been succesfully sent to Registrar. URN-"
      }
      await this.urlApi.addNewurlApi(urlRegistrationForm)
        .subscribe(r => {
          if (r.status == "Success") {
            this.$modal.successModal({
              title: "Whitelisting Request By PE",
              msg: displayMsg + r.message,
            });
            this.router.navigateByUrl("/url-register-list");
          }
          else {
            this.$modal.errorModal({
              title: 'Whitelisting Request By PE',
              msg: r.message

            });

          }
        })
    }

  }

}